import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Input } from "../../../../../../../../../../components/Form";
import { MapStatus } from "../../../../../../../../../../util/enums";

const getSquareBackgroundColor = (status?: string) => {
  switch (status?.toLowerCase()) {
    case MapStatus.EMPTY.toLowerCase():
      return "#CCDEEE";
    case MapStatus.LOADED.toLowerCase():
      return "#53B1FD";
    case MapStatus.MIXED.toLowerCase():
      return "#FAA7E0";
    case MapStatus.INACTIVE.toLowerCase():
      return "#98A2B3";
    default:
      return "#CCDEEE";
  }
};

export const MapSquare = styled("div")(({ status }: { status?: string }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  width: "2rem",
  height: "2rem",
  maxWidth: "2rem",
  maxHeight: "2rem",
  borderRadius: "1px",
  background: getSquareBackgroundColor(status),
  "& button": {
    "& span": {
      display: "none",
    },
  },
}));

export const MapInput = styled(Input, {
  shouldForwardProp: (props) => props !== "isViewMode",
})(({ isViewMode }: { isViewMode: boolean }) => ({
  display: "flex",
  flexDirection: "column",
  width: "2rem",
  height: "2rem",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "4px",
  background: "#FFF",
  "& > div > fieldset": {
    borderRadius: "4px",
    border: isViewMode ? "none" : "1px solid #E4E7EC",
  },
  "& > div > input": {
    padding: 0,
    color: "#308CDB",
    fontSize: "16px",
    fontFamily: "Manrope",
    fontWeight: 700,
    lineHeight: "150%",
    textAlign: "center",
  },
}));

export const MapRow = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "0.5rem",
  "& > .MuiFormControl-root": {
    minWidth: "2rem",
    minHeight: "2rem",
  },
}));

export const BlankCheckbox = styled("div")(() => ({
  height: "1.5rem",
  width: "1.5rem",
  background: "#FFF",
}));

export const MapCellsLevelsWrapper = styled(Grid)(() => ({}));

export const MapCellsLevelsContainer = styled(Grid)(() => ({
  margin: "36px 0 0 -3px !important",
  maxHeight: "25rem !important",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
}));
